/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Row,
  Col,
  Spin,
  Card,
  Input,
  DatePicker,
} from 'antd';
import Table from 'components/Table';
import {
  getClasificacionesDeComercioCatalogo,
  getTiposDeEmpresas,
  getTiposDeEstablecimiento,
} from 'api/empresas';
import {
  getEmpresas,
  postEmpresa,
  baseURI,
} from 'api/empresas/empresas';
import Select from 'components/Select';
import formatValues, { DATE_FRONTEND_FORMAT } from 'utils/formatValues';
import LadaNumero from 'components/LadaNumero';
import FormSubmitControls from 'components/FormSubmitControls';
import { getUnidadesDeRecaudacion } from 'api/configuracion/unidadesDeRecaudacion';
import { getClasesDeActividadesEmpresariales } from 'api/empresas/claseDeActividadEmpresarial';
import { getContribuyente } from 'api/empresas/contribuyentes';
import { EnvironmentOutlined } from '@ant-design/icons';
import ModalDireccion from 'components/ModalDireccion';
import address from 'utils/address';
// import { useSelector } from 'react-redux';

export const model = 'empresa';

export const catalogsModels = [
  'tipodeempresa',
  'contribuyente',
  'clasificaciondecomercio',
  'clasedeactividadempresarial',
  'unidadderecaudacion',
  'ciudadano',
  'estadosglobales',
  'predio',
  'sectorcomercial',
  'tipodeestablecimiento'];

export const permissionConfig = {
  title: 'Empresas',
  model,
  catalogs: catalogsModels,
};

const EmpresasDeContribuyentes = ({
  permission,
  contribuyente,
  mutable = true,
  fetchCallback,
  callback,
}) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({ results: [] });
  const [establecimientos, setEstablecimientos] = useState({ results: [] });
  const [currentPage, setCurrentPage] = useState(1);
  const [visible, setVisible] = useState(false);
  const [ubicacionesEmpresa, setUbicacionEmpresa] = useState([]);
  const [unidadesDeRecaudacion, setUnidadesDeRecaudacion] = useState([]);
  const [tiposDeEmpresa, setTiposDeEmpresa] = useState([]);
  const [claseActividad, setClaseActividad] = useState([]);
  const [clasificacionesDeComercio, setClasificacionesDeComercio] = useState([]);
  const [direccionFiscal, setDireccionFiscal] = useState();
  const [direccionNotificacion, setDireccionNotificacion] = useState();
  // const { estadosGlobales } = useSelector((state) => state.catalogs);

  const fetchData = async (page = 1, q = null) => {
    setLoading(true);
    setCurrentPage(page);
    const _data = await getEmpresas({
      page,
      contribuyente: (contribuyente?.id || contribuyente),
      ...q,
    });
    setData(_data);
    if (fetchCallback) fetchCallback(_data);
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      const [
        _contribuyente,
        _data,
        _establecimientos,
        _tiposEmpresa,
        _claseActividad,
        _clasificacionesDeComercio,
        _unidadesDeRecaudacion,
      ] = await Promise.all([
        getContribuyente(contribuyente?.id || contribuyente),
        getEmpresas({ page: 1, contribuyente: (contribuyente?.id || contribuyente) }),
        getTiposDeEstablecimiento(),
        getTiposDeEmpresas(),
        getClasesDeActividadesEmpresariales(),
        getClasificacionesDeComercioCatalogo(),
        getUnidadesDeRecaudacion(),
      ]);
      // OPCIONES DE UBICACION DE EMPRESA
      const options = [{ id: 0, nombre: 'NINGUNA' }];
      if (_contribuyente?.direcciones) {
        options.push({
          id: 1,
          nombre: 'COPIAR DIRECCIÓN FISCAL DEL CONTRIBUYENTE',
        });
      }
      if (_contribuyente?.direcciones_de_notificacion) {
        options.push({
          id: 2,
          nombre: 'COPIAR DIRECCIÓN DE NOTIFICACIÓN DEL CONTRIBUYENTE',
        });
      }
      options.push({
        id: 3,
        nombre: 'AGREGAR NUEVA DIRECCIÓN',
      });
      if (mounted) {
        if (fetchCallback) fetchCallback(_data);
        _data.page = 1;
        setUbicacionEmpresa(options);
        setDireccionFiscal(_contribuyente.direcciones);
        setDireccionNotificacion(_contribuyente.direcciones_de_notificacion);
        setEstablecimientos(_establecimientos);
        setUnidadesDeRecaudacion(_unidadesDeRecaudacion);
        setClasificacionesDeComercio(_clasificacionesDeComercio);
        setClaseActividad(_claseActividad);
        setTiposDeEmpresa(_tiposEmpresa);
        setData(_data);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onCancel = () => {
    setSelectedRowKeys([]);
    form.resetFields();
    setVisible(false);
  };
  const onClickAddress = () => document.querySelector('#btn-direccion')?.click();

  const onFinish = async () => {
    setLoading(true);
    const { direccion_de_ubicacion, ...values } = form.getFieldsValue();
    if ([1, 2].includes(direccion_de_ubicacion)) {
      const addressMap = {
        1: direccionFiscal,
        2: direccionNotificacion,
      };
      const direccion = addressMap[direccion_de_ubicacion];
      delete direccion.id;
      values.direccion_de_ubicacion = formatValues(direccion);
      values.direccion_de_ubicacion.codigo_postal = direccion.codigo_postal.id;
      if (values.direccion_de_ubicacion.entre_calle === 'N/A') {
        delete values.direccion_de_ubicacion.entre_calle;
      }
      if (values.direccion_de_ubicacion.y_calle === 'N/A') {
        delete values.direccion_de_ubicacion.y_calle;
      }
    }
    values.contribuyente = contribuyente.id || contribuyente;
    const saved = await postEmpresa(values);
    if (saved) {
      if (callback) {
        saved.message = `Empresa ${saved.clave} agregada`;
        callback(saved);
      }
      onCancel();
      if (direccion_de_ubicacion === 3) {
        const page = data.count % 10 === 0 ? data.count / 10 : (parseInt(data.count / 10, 10) + 1);
        await fetchData(page);
        setTimeout(() => {
          setSelectedRowKeys([saved.id]);
          onClickAddress();
        });
      } else {
        await fetchData();
      }
    }
    setLoading(false);
  };

  const onClickAdd = () => {
    onCancel();
    setVisible('form');
  };

  const onClickEdit = () => setVisible('form');

  const handleOnRowClick = (record) => {
    form.setFieldsValue(record);
    setSelectedRowKeys([record.id]);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const columns = [
    {
      titleText: 'Clave del Establecimiento',
      key: 'clave',
      dataIndex: 'clave',
      width: 300,
    },
    {
      titleText: 'Nombre del Establecimiento',
      key: 'nombre_comercial',
      dataIndex: 'nombre_comercial',
      width: 300,
    },
    fetchCallback && {
      titleText: 'Tipo de Establecimiento',
      key: 'tipo_de_establecimiento',
      dataIndex: 'tipo_de_establecimiento',
      render: (est) => establecimientos.find((e) => e.id === est)?.nombre,
      width: 300,
    },
    fetchCallback && {
      titleText: 'Dirección',
      key: 'direccion_de_ubicacion',
      dataIndex: 'direccion_de_ubicacion',
      render: address,
      width: 300,
    },
    {
      titleText: 'Fecha de Apertura',
      key: 'fecha_de_apertura',
      dataIndex: 'fecha_de_apertura',
      render: (fecha_de_apertura) => fecha_de_apertura?.format(),
      width: 300,
    },
  ].filter((e) => e);

  return (
    <Row align="center" justify="center" className="container">
      <Col span={24}>
        <Spin tip="Cargando..." spinning={loading}>
          {visible !== 'form' && (
            <Table
              cols={columns}
              data={data?.results}
              rowSelection={rowSelection}
              handleOnRowClick={handleOnRowClick}
              controls={mutable ? {
                onClickAdd,
                onClickEdit,
              } : { onClickExpand: onClickEdit }}
              customActions={mutable ? [
                {
                  onClick: onClickAddress,
                  icon: <EnvironmentOutlined />,
                  text: 'Dirección',
                },
              ] : []}
              allowExpand
              rowKey="id"
              permission={permission}
              pagination={false}
              paginationCallback={fetchData}
              count={data.count}
              currentPage={currentPage}
              hasAllViewPermission
            />
          )}
          {visible === 'form' && (
            <Card
              title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Empresa`}
              extra={(
                <FormSubmitControls
                  onFinish={mutable ? onFinish : null}
                  onCancel={onCancel}
                  loading={loading}
                />
              )}
            >
              <Form
                name="info"
                layout="vertical"
                form={form}
                onFinish={() => onFinish()}
                scrollToFirstError
                initialValues={{
                  tipo_de_persona: 1,
                  unidad_recaudadora: contribuyente.unidad_de_recaudacion,
                }}
              >
                <Row gutter={10}>
                  <Col md={8} sm={24} xs={24}>
                    <Form.Item
                      label="Nombre comercial"
                      name="nombre_comercial"
                      rules={[{ required: true }]}
                    >
                      <Input disabled={!mutable} allowClear />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="unidad_recaudadora"
                      label="Unidad Recaudadora"
                    >
                      <Select disabled={!mutable} dataSource={unidadesDeRecaudacion} allowClear />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="tipo_de_empresa"
                      label="Tipo de Empresa"
                      hasFeedback
                    >
                      <Select disabled={!mutable} dataSource={tiposDeEmpresa} />
                    </Form.Item>
                  </Col>
                  <Col md={8} sm={24} xs={24}>
                    <Form.Item
                      label="Tipo de establecimiento"
                      name="tipo_de_establecimiento"
                    >
                      <Select
                        disabled={!mutable}
                        dataSource={establecimientos}
                        labelProp="nombre"
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="clasificacion_de_comercio"
                      label="Clasificación de comercio"
                      hasFeedback
                    >
                      <Select disabled={!mutable} dataSource={clasificacionesDeComercio} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="clase_actividad_empresarial_principal"
                      label="Clase Actividad"
                      hasFeedback
                      tooltip="Clase Actividad Empresarial"
                    >
                      <Select disabled={!mutable} dataSource={claseActividad} allowClear />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="fecha_de_apertura"
                      label="Fecha de apertura"
                      hasFeedback
                    >
                      <DatePicker disabled={!mutable} format={DATE_FRONTEND_FORMAT} placeholder="" />
                    </Form.Item>
                  </Col>
                  {/* <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="fecha_de_cierre"
                      label="Fecha de cierre"
                      hasFeedback
                    >
                      <DatePicker format={DATE_FRONTEND_FORMAT} placeholder="" />
                    </Form.Item>
                  </Col> */}
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="fecha_de_alta_de_padron_empresa"
                      label="Fecha de alta de Padrón"
                      hasFeedback
                    >
                      <DatePicker disabled={!mutable} format="DD/MM/YYYY" placeholder="" />
                    </Form.Item>
                  </Col>
                  <Col md={8} sm={24} xs={24}>
                    <Form.Item
                      label="Dirección de Ubicación"
                      name="direccion_de_ubicacion"
                    >
                      <Select
                        disabled={!mutable}
                        dataSource={ubicacionesEmpresa}
                        labelProp="nombre"
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <LadaNumero
                      form={form}
                      names={{
                        lada: 'lada_fijo',
                        numero_de_telefono: 'telefono_fijo',
                      }}
                      tooltip="Teléfono Fijo de la Empresa"
                      label="Teléfono Fijo"
                      fullSize
                      disabled={!mutable}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <LadaNumero
                      form={form}
                      names={{
                        lada: 'lada_celular',
                        numero_de_telefono: 'telefono_celular',
                      }}
                      tooltip="Teléfono Celular de la Empresa"
                      label="Teléfono Celular"
                      fullSize
                      disabled={!mutable}
                    />
                  </Col>
                  {/* <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="estados_globales"
                      label="Estado"
                      hasFeedback
                    >
                      <Select disabled={!mutable} dataSource={estadosGlobales} />
                    </Form.Item>
                  </Col> */}
                  <Col xs={24} sm={24} md={16}>
                    <Form.Item
                      name="observaciones"
                      label="Observaciones"
                    >
                      <Input.TextArea
                        disabled={!mutable}
                        autoSize={{ minRows: 2, maxRows: 3 }}
                        maxLength={250}
                        allowClear
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Card>
          )}
        </Spin>
      </Col>
      <div style={{ display: 'none' }}>
        <ModalDireccion
          parentID={selectedRowKeys[0]}
          currentURI={baseURI}
          addressPropName="direccion_de_ubicacion"
          callback={() => fetchData(data.page)}
          visible={visible === 'address'}
          onCancel={() => setVisible(false)}
        />
      </div>
    </Row>
  );
};

export default EmpresasDeContribuyentes;
